import "../assets/scss/style.scss";

import React, { useEffect } from "react";

import DemoModal from "../components/common/DemoModal";
import Footer from "../components/common/Footer";
import Header from "../components/layout/Header";
import HeaderNav from "../components/layout/HeaderNav";

interface LayoutDefaultProps {
  children?: React.ReactNode;
}

const LayoutDefault: React.FunctionComponent<LayoutDefaultProps> = ({
  children,
}) => {
  useEffect(() => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <>
      <Header nav={<HeaderNav logoWhiteAtTop={false} />} />
      <main style={{ flex: "1 0 auto", paddingTop: "0" }}>{children}</main>
      <Footer />
      <DemoModal />
    </>
  );
};

export default LayoutDefault;
